module.exports = __webpack_public_path__ + "img/subject_banner2.5edf9f15.png";